import React, { useState, useEffect } from "react";
import {
	Modal,
	Form,
	Select,
	DatePicker,
	Input,
	Button,
	message,
	Typography,
} from "antd";
import useAxios from "../../utilities/useAxios";
import dayjs from "dayjs";
import useIsMobile from "../../hooks/useIsMobile";

const { TextArea } = Input;
const { Option } = Select;

const EditStatusModal = ({
	visible,
	onCancel,
	onSuccess,
	userId,
	currentStatus,
}) => {
	const isMobile = useIsMobile();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [statuses, setStatuses] = useState([]);

	useEffect(() => {
		if (visible) {
			getStatuses();
			form.setFieldsValue({
				changed_status: currentStatus,
				changed_date: dayjs(),
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- form is stable
	}, [visible, currentStatus]);

	const getStatuses = async () => {
		try {
			const response = await useAxios.get("/users/statuses/");
			if (response.status === 200) {
				setStatuses(response.data);
			}
		} catch (error) {
			message.error("상태 목록을 불러오는데 실패했습니다.");
		}
	};

	const handleSubmit = async () => {
		try {
			setLoading(true);
			const values = await form.validateFields();

			const updateData = {
				status_id: values.changed_status,
				status_change: {
					changed_date:
						values.changed_date.format(
							"YYYY-MM-DD"
						),
					changed_status: statuses.find(
						(s) =>
							s.id ===
							values.changed_status
					)?.name,
				},
				reason: values.reason,
			};

			const response = await useAxios.put(
				`/users/update-status/${userId}/`,
				updateData
			);

			if (response.status === 200) {
				message.success(
					"상태가 성공적으로 수정되었습니다."
				);
				onSuccess();
				form.resetFields();
			}
		} catch (error) {
			message.error("상태 수정에 실패했습니다.");
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		form.resetFields();
		onCancel();
	};

	return (
		<Modal
			title="상태 수정"
			open={visible}
			onCancel={handleCancel}
			footer={[
				<Button key="cancel" onClick={handleCancel}>
					취소
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={loading}
					onClick={handleSubmit}>
					수정
				</Button>,
			]}
			width={500}>
			<Form form={form} layout="vertical">
				<Form.Item
					name="changed_status"
					label="상태"
					rules={[
						{
							required: true,
							message: "상태를 선택해주세요",
						},
					]}>
					<Select placeholder="상태 선택">
						{statuses.map((status) => (
							<Option
								key={status.id}
								value={
									status.id
								}>
								{status.name}
							</Option>
						))}
					</Select>
				</Form.Item>

				<Form.Item
					name="changed_date"
					label="변경일"
					rules={[
						{
							required: true,
							message: "변경일을 선택해주세요",
						},
					]}>
					<DatePicker
						inputReadOnly={isMobile}
						style={{ width: "100%" }}
						format="YYYY-MM-DD"
						placeholder="변경일 선택"
					/>
				</Form.Item>

				<Form.Item
					name="reason"
					label="이유"
					rules={[
						{
							required: true,
							message: "이유를 입력해주세요",
						},
					]}>
					<TextArea rows={2} />
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditStatusModal;
